import { GristEventHandler } from '../types.js'
import { ContextMenuTreeMutation } from './contextmenu-tree-mutation.js'
import { MoveDown } from './move-down.js'
import { MoveUp } from './move-up.js'
import { RecordCopy } from './record-copy.js'
import { RecordDelete } from './record-delete.js'
import { RecordViewHandler } from './record-view-handler.js'
import { SelectRow } from './select-row.js'
import { SelectRowToggle } from './select-row-toggle.js'

var HANDLERS: {
  [name: string]: GristEventHandler
} = {
  'record-view': RecordViewHandler as GristEventHandler,
  'select-row': SelectRow as GristEventHandler,
  'select-row-toggle': SelectRowToggle as GristEventHandler,
  'move-up': MoveUp as GristEventHandler,
  'move-down': MoveDown as GristEventHandler,
  'record-copy': RecordCopy as GristEventHandler,
  'record-delete': RecordDelete as GristEventHandler,
  'contextmenu-tree-mutation': ContextMenuTreeMutation as GristEventHandler
}

export function registerGristEventHandler(type: string, handler: GristEventHandler) {
  HANDLERS[type] = handler
}

export function unregisterGristEventHandler(type: string) {
  delete HANDLERS[type]
}

export function getGristEventHandlers() {
  return { ...HANDLERS }
}

export function getGristEventHandler(type: string | GristEventHandler): GristEventHandler {
  if (typeof type == 'function') {
    return type
  }

  return HANDLERS[type]
}
